import { useEffect, useRef } from "react";
import { coreState } from "../lib/util";

// Fixed atmospheric background; brightens into a luminous environment near the final section.
export const Backdrop = () => {
  const lum = useRef(null);
  useEffect(() => {
    let raf;
    const tick = () => {
      const f = document.getElementById("final");
      const vh = window.innerHeight;
      let l = 0;
      if (f) {
        const top = f.getBoundingClientRect().top;
        l = Math.min(1, Math.max(0, (vh - top) / (vh * 0.6)));
      }
      coreState.lum = l;
      if (lum.current) lum.current.style.opacity = String(l);
      raf = requestAnimationFrame(tick);
    };
    tick();
    return () => cancelAnimationFrame(raf);
  }, []);

  return (
    <div aria-hidden className="pointer-events-none fixed inset-0 z-0 bg-noor-deep">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_70%_60%_at_70%_40%,rgba(10,74,68,0.75),transparent_70%)] rtl:bg-[radial-gradient(ellipse_70%_60%_at_30%_40%,rgba(10,74,68,0.75),transparent_70%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_50%_40%_at_20%_100%,rgba(171,127,62,0.14),transparent_70%)]" />
      <div ref={lum} className="absolute inset-0 opacity-0 bg-[radial-gradient(ellipse_80%_70%_at_50%_30%,#FFFFFA_0%,#F4EFE3_50%,#E2D8C3_100%)]" />
    </div>
  );
};
